// extracted by mini-css-extract-plugin
export default {"eventdetailstable":"index_eventdetailstable__3TqaE"};